import { TableCell } from "@mui/material";

interface MaterialCostColumnProps {
  isOpenSecondTierProcessColumn: boolean;
  setIsOpenSecondTierProcessColumn: React.Dispatch<React.SetStateAction<boolean>>;
  secondTierProcessColumn: { id: number; name: string }[];
  isOpenOtherProcessColumn: boolean;
  setIsOpenOtherProcessColumn: React.Dispatch<React.SetStateAction<boolean>>;
  otherProcessColumn: { id: number; name: string }[];
  isAdminPct: boolean;
  isProfitPct: boolean;
}

const MaterialCostColumn = ({
  isOpenSecondTierProcessColumn,
  setIsOpenSecondTierProcessColumn,
  secondTierProcessColumn,
  isOpenOtherProcessColumn,
  setIsOpenOtherProcessColumn,
  otherProcessColumn,
  isAdminPct,
  isProfitPct,
}: MaterialCostColumnProps) => {
  return (
    <>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Total Material Cost (THB/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Material Cost (THB/pcs)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "center",
        }}
      >
        Purchase Part
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Return Scrap (THB)
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Admin {isAdminPct ? "(%)" : "(THB/pcs)"}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Profit {isProfitPct ? "(%)" : "(THB/pcs)"}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 180,
          maxWidth: 180,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenSecondTierProcessColumn ? "secondary.light" : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenSecondTierProcessColumn(!isOpenSecondTierProcessColumn)
        }}
      >
        2nd Tier Process Total (THB/pcs)
      </TableCell>
      {isOpenSecondTierProcessColumn &&
        secondTierProcessColumn
          ?.sort((a, b) => a.id - b.id)
          .map((process) => (
            <TableCell
              key={process.id}
              sx={{
                minWidth: 120,
                maxWidth: 120,
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                textAlign: "right",
                bgcolor: "primary.light",
              }}
            >
              {process.name} (THB/pcs)
            </TableCell>
          ))}
      <TableCell
        sx={{
          minWidth: 180,
          maxWidth: 180,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          bgcolor: isOpenOtherProcessColumn ? "secondary.light" : "secondary.main",
          cursor: "pointer",
        }}
        onClick={() => {
          setIsOpenOtherProcessColumn(!isOpenOtherProcessColumn)
        }}
      >
        Other Process Total (THB/pcs)
      </TableCell>
      {isOpenOtherProcessColumn &&
        otherProcessColumn
          ?.sort((a, b) => a.id - b.id)
          .map((process) => (
            <TableCell
              key={process.id}
              sx={{
                minWidth: 120,
                maxWidth: 120,
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                textAlign: "right",
                bgcolor: "primary.light",
              }}
            >
              {process.name} (THB/pcs)
            </TableCell>
          ))}
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        %
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
        }}
      >
        Other (%)
      </TableCell>
    </>
  );
};

export default MaterialCostColumn;
